
import React from "react";
import "./landingpage.css";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { analytics } from "../../services/firebaseConnection";
import { logEvent } from "firebase/analytics";

import logo from "../../assets/logo_lp.png";


export default function LandingPage() {

    const [chatOpen, setChatOpen] = useState(false);


    useEffect(() => {

        const header = document.getElementById("header");

        // Header ao rolar
        function handleHeaderScroll() {

            if (window.scrollY > 40) {
                header?.classList.add("is-scrolled");
            } else {
                header?.classList.remove("is-scrolled");
            }

        }

        handleHeaderScroll();

        window.addEventListener("scroll", handleHeaderScroll, {
            passive: true
        });


        // CTA flutuante mobile
        const floatingCta = document.getElementById("floatingCta");
        const demoSection = document.getElementById("demonstracao");
        const heroSection = document.querySelector(".hero");

        let heroObserver = null;
        let demoObserver = null;

        if ("IntersectionObserver" in window && floatingCta) {

            heroObserver = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {

                    if (
                        !entry.isIntersecting &&
                        window.innerWidth <= 640
                    ) {

                        floatingCta.classList.add("show");

                    } else {

                        floatingCta.classList.remove("show");

                    }

                });

            }, {
                threshold: 0
            });


            if (heroSection) {
                heroObserver.observe(heroSection);
            }


            demoObserver = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {
                        floatingCta.classList.remove("show");
                    }

                });

            }, {
                threshold: 0.2
            });


            if (demoSection) {
                demoObserver.observe(demoSection);
            }

        }


        // Esconde WhatsApp no rodapé
        const footerBottomRow = document.getElementById("footerBottomRow");
        const waFloatWrap = document.getElementById("waFloatWrap");

        let footerObserver = null;

        if (
            footerBottomRow &&
            "IntersectionObserver" in window
        ) {

            footerObserver = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        if (waFloatWrap) {
                            waFloatWrap.classList.add("is-hidden");
                        }

                        if (floatingCta) {
                            floatingCta.classList.remove("show");
                        }

                    } else {

                        if (waFloatWrap) {
                            waFloatWrap.classList.remove("is-hidden");
                        }

                    }

                });

            }, {
                threshold: 0,
                rootMargin: "0px 0px -10px 0px"
            });


            footerObserver.observe(footerBottomRow);

        }


        // Animação reveal
        const revealEls = document.querySelectorAll(".reveal");

        let revealObserver = null;

        if ("IntersectionObserver" in window) {

            revealObserver = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {

                    if (entry.isIntersecting) {

                        entry.target.classList.add("is-visible");

                        revealObserver.unobserve(entry.target);

                    }

                });

            }, {
                threshold: 0.12
            });


            revealEls.forEach((el) => {
                revealObserver.observe(el);
            });

        } else {

            revealEls.forEach((el) => {
                el.classList.add("is-visible");
            });

        }


        // Scroll suave dos menus
        const headerHeight = () => {
            return header ? header.offsetHeight + 12 : 12;
        };

        const anchorLinks = document.querySelectorAll(
            'a[href^="#"]'
        );

        const anchorHandlers = [];

        anchorLinks.forEach((link) => {

            const handler = (e) => {

                const targetId = link.getAttribute("href");

                if (!targetId || targetId.length <= 1) {
                    return;
                }

                const target = document.querySelector(targetId);

                if (!target) {
                    return;
                }

                e.preventDefault();

                const top =
                    target.getBoundingClientRect().top +
                    window.pageYOffset -
                    headerHeight();

                window.scrollTo({
                    top,
                    behavior: "smooth"
                });

            };

            link.addEventListener("click", handler);

            anchorHandlers.push({
                link,
                handler
            });

        });


        // FAQ
        const faqItems = document.querySelectorAll(".faq-item");

        const faqHandlers = [];

        faqItems.forEach((item) => {

            const q = item.querySelector(".faq-q");
            const a = item.querySelector(".faq-a");

            if (!q || !a) {
                return;
            }

            const handler = () => {

                const isOpen = item.classList.contains("open");


                document
                    .querySelectorAll(".faq-item.open")
                    .forEach((openItem) => {

                        if (openItem !== item) {

                            openItem.classList.remove("open");

                            const openAnswer =
                                openItem.querySelector(".faq-a");

                            if (openAnswer) {
                                openAnswer.style.maxHeight = null;
                            }

                        }

                    });


                if (isOpen) {

                    item.classList.remove("open");

                    a.style.maxHeight = null;

                } else {

                    item.classList.add("open");

                    a.style.maxHeight =
                        a.scrollHeight + "px";

                }

            };

            q.addEventListener("click", handler);

            faqHandlers.push({
                q,
                handler
            });

        });


        // Máscara WhatsApp
        const whatsappInput =
            document.getElementById("whatsapp");

        let whatsappHandler = null;

        if (whatsappInput) {

            whatsappHandler = function () {

                let v = this.value
                    .replace(/\D/g, "")
                    .slice(0, 11);


                if (v.length > 10) {

                    v = v.replace(
                        /(\d{2})(\d{5})(\d{0,4})/,
                        "($1) $2-$3"
                    );

                } else if (v.length > 5) {

                    v = v.replace(
                        /(\d{2})(\d{4})(\d{0,4})/,
                        "($1) $2-$3"
                    );

                } else if (v.length > 2) {

                    v = v.replace(
                        /(\d{2})(\d{0,5})/,
                        "($1) $2"
                    );

                } else if (v.length > 0) {

                    v = v.replace(
                        /(\d{0,2})/,
                        "($1"
                    );

                }

                this.value = v.trim();

            };

            whatsappInput.addEventListener(
                "input",
                whatsappHandler
            );

        }


        // Chat demonstrativo
        const chatBody =
            document.getElementById("chatBody");

        const chatScript = [

            {
                side: "in",
                text: "Oi",
                time: "09:14"
            },

            {
                side: "out",
                text: "Olá! eu sou o assistente virtual do Dr. Pedro Silva. Como posso te ajudar?",
                time: "09:14"
            },

            {
                side: "in",
                text: "Eu gostaria de marcar uma consulta, tem disponibilidade para hoje?",
                time: "09:15"
            },

            {
                side: "out",
                text: "Para hoje não mas temos disponibilidade para amanhã as 09:00, 10:00 e 14:00 hrs.",
                time: "09:15"
            },

            {
                side: "in",
                text: "O horários das 10h está ótimo!",
                time: "09:16"
            },

            {
                side: "out",
                text: "Consulta confirmada para amanhã, 10h. ✅",
                time: "09:16"
            }

        ];


        function typingIndicator() {

            const el = document.createElement("div");

            el.className = "typing-dots";

            el.innerHTML =
                "<span></span><span></span><span></span>";

            return el;

        }


        function runChat() {

            if (!chatBody) {
                return;
            }

            chatBody.innerHTML = "";

            let delay = 400;


            chatScript.forEach((msg) => {

                const showTyping =
                    msg.side === "out";


                if (showTyping) {

                    setTimeout(() => {

                        const typing =
                            typingIndicator();

                        chatBody.appendChild(typing);

                        chatBody.scrollTop =
                            chatBody.scrollHeight;

                        setTimeout(() => {
                            typing.remove();
                        }, 900);

                    }, delay);

                    delay += 1000;

                }


                setTimeout(() => {

                    const bubble =
                        document.createElement("div");

                    bubble.className =
                        "bubble " + msg.side;

                    bubble.innerHTML =
                        msg.text +
                        '<span class="time">' +
                        msg.time +
                        "</span>";

                    chatBody.appendChild(bubble);

                    chatBody.scrollTop =
                        chatBody.scrollHeight;

                }, delay);

                delay += 1300;

            });


            setTimeout(
                runChat,
                delay + 3500
            );

        }


        let chatObserver = null;

        if (chatBody) {

            if ("IntersectionObserver" in window) {

                let started = false;

                chatObserver =
                    new IntersectionObserver((entries) => {

                        entries.forEach((entry) => {

                            if (
                                entry.isIntersecting &&
                                !started
                            ) {

                                started = true;

                                runChat();

                            }

                        });

                    }, {
                        threshold: 0.3
                    });


                chatObserver.observe(chatBody);

            } else {

                runChat();

            }

        }


        // Formulário
        const leadForm =
            document.getElementById("leadForm");

        const formError =
            document.getElementById("formError");

        const submitBtn =
            document.getElementById("submitBtn");

        let formHandler = null;

        if (leadForm) {

            formHandler = (e) => {

                const nome =
                    document.getElementById("nome")?.value.trim();

                const clinica =
                    document.getElementById("clinica")?.value.trim();

                const whatsapp =
                    document.getElementById("whatsapp")?.value.trim();

                const email =
                    document.getElementById("email")?.value.trim();

                const consent =
                    document.getElementById("consent")?.checked;


                const emailRegex =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                const whatsappDigits =
                    whatsapp?.replace(/\D/g, "") || "";


                let valid = true;


                if (!nome || !clinica) {
                    valid = false;
                }

                if (whatsappDigits.length < 10) {
                    valid = false;
                }

                if (!emailRegex.test(email || "")) {
                    valid = false;
                }

                if (!consent) {
                    valid = false;
                }


                if (!valid) {

                    e.preventDefault();

                    if (formError) {

                        formError.textContent =
                            !consent
                                ? "É necessário autorizar o contato para enviar o formulário."
                                : "Por favor, preencha todos os campos corretamente.";

                        formError.classList.add("show");

                    }

                    return;

                }


                if (formError) {
                    formError.classList.remove("show");
                }

                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = "Enviando...";
                }

            };

            leadForm.addEventListener(
                "submit",
                formHandler
            );

        }


        // Cleanup quando o componente desmontar
        return () => {

            window.removeEventListener(
                "scroll",
                handleHeaderScroll
            );


            if (heroObserver) {
                heroObserver.disconnect();
            }

            if (demoObserver) {
                demoObserver.disconnect();
            }

            if (footerObserver) {
                footerObserver.disconnect();
            }

            if (revealObserver) {
                revealObserver.disconnect();
            }

            if (chatObserver) {
                chatObserver.disconnect();
            }


            anchorHandlers.forEach(({ link, handler }) => {
                link.removeEventListener("click", handler);
            });


            faqHandlers.forEach(({ q, handler }) => {
                q.removeEventListener("click", handler);
            });


            if (whatsappInput && whatsappHandler) {
                whatsappInput.removeEventListener(
                    "input",
                    whatsappHandler
                );
            }


            if (leadForm && formHandler) {
                leadForm.removeEventListener(
                    "submit",
                    formHandler
                );
            }

        };

    }, []);


    function SupportChat() {
        return (
            <iframe
                src="https://app.gptmaker.ai/widget/3EFFB416257393E9DF89FE8BA71AB4AF/iframe"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none"
                }}
                allow="microphone;"
                title="Chat Suporte"
            />
        );
    }


    return (

        <div className="landing-page">

            {/* Header */}
            <header className="lp_header" id="header">

                <div className="wrap">

                    <a href="#" className="logo"><img src={logo} alt="Winners AI" /></a>

                    <nav className="nav-links">
                        <a href="#como-funciona" onClick={() => {logEvent(analytics, "lp_menu_click", {menu: "funciona"});}}>Como funciona</a>
                        <a href="#beneficios" onClick={() => {logEvent(analytics, "lp_menu_click", {menu: "beneficio"});}}>Benefícios</a>
                        <a href="#especialidades" onClick={() => {logEvent(analytics, "lp_menu_click", {menu: "quem"});}}>Para quem é</a>
                        <a href="#faq" onClick={() => {logEvent(analytics, "lp_menu_click", {menu: "faq"});}}>Dúvidas</a>
                    </nav>

                    <div className="lp_header-cta">
                        {/*<a href="tel:+551153046350" className="btn btn-secondary">Falar com Especialista</a>
                        <a href="#demonstracao" className="btn btn-primary">Quero saber mais detalhes</a>*/}
                        <Link to="/register" className="btn btn-primary" onClick={() => {logEvent(analytics, "lp_button_click", {button: "testar_menu"});}}>Quero testar gratuitamente</Link>
                    </div>

                </div>

            </header>

            {/* Hero */}
            <section className="hero">

                <div className="wrap">

                    <div className="hero-copy reveal">

                        <span className="eyebrow">AGENTES ESPECIALIZADOS: área da saúde</span>
                        <h1>Seu atendimento inteligente,{" "}<span className="hl">funcionando 24 horas por dia.</span></h1>
                        <p className="lead">Gerencie agendamentos, responda multiplos pacientes instantaneamente, tenha um colabordor disponível 7 dias por semana e 24 horas por dia.</p>

                        <ul className="hero-trust">
                            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>7 dias grátis para testar</li>
                            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>Número de linha exclusivo para WhatsApp</li>
                            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>Agenda personalizável e exclusiva</li>
                        </ul>

                    </div>

                    <div className="hero-visual reveal">

                        <div className="phone-mock"><span className="phone-badge top"><span className="dot"></span>Agente online</span><div className="phone-frame">
                                <div className="phone-screen">
                                    <div className="phone-chat-header"><div className="avatar">W</div>
                                        <div>
                                            <div className="who">Agente Pedro</div>
                                            {/*<div className="status">Consultório Dr. Ricardo Almeida</div>*/}
                                        </div>
                                    </div>
                                    <div className="chat-body" id="chatBody"></div>
                                    <div className="chat-footer">
                                        <div className="field"></div>
                                        <div className="send"></div>
                                    </div>
                                </div>
                            </div>
                            <span className="phone-badge bottom">✓ Consulta agendada</span>
                        </div>

                    </div>

                </div>

            </section>


            {/* Dores */}
            <section className="dores" id="dores">
                <div className="wrap">
                    <div className="section-head reveal">
                        <span className="eyebrow">Isso parece familiar?</span>
                        <h2>O dia a dia de quem atende sozinho.</h2>
                        <p>Entre consultas e pacientes, a rotina de agendamento acaba sobrecarregando quem deveria estar cuidando de gente.</p>
                    </div>

                    <div className="dores-grid">
                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
                                </svg>
                            </div><h3>WhatsApp lotado</h3><p>Mensagens se acumulam e o tempo de resposta cresce a cada dia.</p>
                        </div>

                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="8" r="4" />
                                    <path d="M4 21v-1a6 6 0 016-6h4a6 6 0 016 6v1" />
                                </svg>
                            </div><h3>Secretária ausente</h3><p>Férias, folgas, motivos pessoais ... seus pacientes nem sempre esperam o retorno do colaborador.</p>
                        </div>

                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="9" />
                                    <path d="M12 7v5l3 3" />
                                </svg>
                            </div><h3>Pacientes aguardando resposta</h3><p>Cada minuto de espera é uma chance a mais de o paciente procurar outro lugar.</p>
                        </div>

                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2"/>
                                    <path d="M16 2v4M8 2v4M3 10h18" />
                                </svg>
                            </div><h3>Perda de agendamentos</h3><p>Consultas que não são confirmadas a tempo viram horários vazios na agenda.</p>
                        </div>

                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="9" />
                                    <path d="M12 7v5l3 3M7 3l-2 2M17 3l2 2" />
                                </svg>
                            </div><h3>Atendimento fora do horário</h3><p>Fora do expediente, quem tenta marcar consulta simplesmente não é atendido.</p>
                        </div>

                        <div className="dor-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
                                </svg>
                            </div><h3>Alto custo operacional</h3>
                            <p>Ampliar a equipe só para atender WhatsApp encarece a operação da clínica.</p>
                        </div>

                    </div>
                </div>
            </section>

            {/* Solução */}
            <section className="solucao" id="como-funciona">
                <div className="wrap">
                    <div className="solucao-visual reveal">
                        <div className="step-line">

                            <div className="mini-step">
                                <div className="num">1</div>
                                <div><strong>Cadastro e acesso a plataforma</strong><span>Cadastre-se com poucas informações e acesse a plataforma.</span></div>
                            </div>
                            <div className="mini-step">
                                <div className="num">2</div>
                                <div><strong>Crie seu agente</strong><span>Escolha um nome e a área que seu agente irá atuar.</span></div>
                            </div>
                            <div className="mini-step">
                                <div className="num">3</div>
                                <div><strong>Configure seu agente</strong><span>Insira as informações sobre seu atendimento e agenda.</span></div>
                            </div>
                            <div className="mini-step">
                                <div className="num">4</div>
                                <div><strong>Pronto! seu agente já pode atender</strong><span>24 horas por dia, todos os dias da semana.</span></div>
                            </div>

                        </div>
                    </div>

                    <div className="solucao-text reveal">
                        <span className="eyebrow">A solução</span>
                        <h2>Um agente de IA, treinado com as suas informações.</h2>
                        <p>
                            Um agente de IA é um programa que usa inteligência
                            artificial para realizar tarefas de forma autônoma.
                            De forma análoga, é como ter um ajudante para todas
                            as tarefas administrativas repetitivas do seu
                            consultório.
                        </p>
                        <p>
                            A Plataforma da Winners-AI configura esse agente como uma
                            secretária virtual do seu consultório: ele conversa
                            de forma fluida e não mecanizada, entende o
                            vocabulário, consulta sua
                            agenda e conduz o paciente até o agendamento, sem
                            que ninguém da sua equipe precise intervir.
                        </p>
                        {/*<a href="#demonstracao" className="btn btn-primary">Ver como funciona na prática</a>*/}

                    </div>
                </div>
            </section>


            {/* Benefícios */}
            <section className="beneficios" id="beneficios">

                <div className="wrap">
                    <div
                        className="section-head center reveal" style={{marginLeft: "auto", marginRight: "auto"}}>
                        <span className="eyebrow" style={{justifyContent: "center"}}>Por que a Winners-AI</span>
                        <h2>Feita para quem não tem tempo a perder.</h2>
                    </div>


                    <div className="ben-grid">
                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="9" />
                                    <path d="M12 7v5l3 3" />
                                </svg>
                            </div>
                            <h3>Atendimento 24h</h3>
                            <p>Seus pacientes são atendidos a qualquer hora, inclusive fora do expediente.</p>
                        </div>

                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M13 2L3 14h8l-1 8 10-12h-8z" />
                                </svg>
                            </div>
                            <h3>Respostas instantâneas</h3>
                            <p>Nenhum paciente espera minutos, muito menos horas, por uma resposta.</p>
                        </div>

                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="3" y="4" width="18" height="18" rx="2"/>
                                    <path d="M16 2v4M8 2v4M3 10h18M9 16l2 2 4-4" />
                                </svg>
                            </div>
                            <h3>Agendamento</h3>
                            <p>Seu agente busca horários, agenda, cancela e remarca agendamentos de sua agenda.</p>
                        </div>

                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2l2.6 6.2L21 9l-5 4.6L17.4 21 12 17.4 6.6 21 8 13.6 3 9l6.4-.8z" />
                                </svg>
                            </div>
                            <h3>IA treinada</h3>
                            <p>Todo o contexto das conversas são baseadas nas informações que você passa ao agente.</p>
                        </div>

                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
                                </svg>
                            </div>
                            <h3>Redução de custos</h3>
                            <p>Menos necessidade de ampliar a equipe só para dar conta do WhatsApp.</p>
                        </div>

                        <div className="ben-card reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M3 3v18h18M7 15l4-4 3 3 5-6" />
                                </svg>
                            </div>
                            <h3>Escalabilidade</h3>
                            <p>Atende 1 ou 50 conversas ao mesmo tempo, sem perder qualidade.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Especialidades */}
            <section className="especialidades" id="especialidades">

                <div className="wrap">
                    <div className="section-head center reveal" style={{marginLeft: "auto", marginRight: "auto"}}>
                        <span className="eyebrow" style={{justifyContent: "center"}}>Para quem é</span>
                        <h2>Área médica em geral</h2>
                    </div>

                    <div className="chip-row reveal">
                        <span className="chip">Clínicas</span>
                        <span className="chip">Consultórios</span>
                        <span className="chip">Médico particular</span>
                        <span className="chip">Necessidade de atendimento próprio</span>
                        <span className="chip">Não quer arcar com os custos de um colaborador humano</span>
                    </div>

                </div>

            </section>


            {/* Confiança */}
            <section className="confianca">
                <div className="wrap">
                    <div className="section-head reveal">
                        <span className="eyebrow">Antes de decidir</span>
                        <h2>O que você precisa saber.</h2>
                        <p>
                            Winners Ltda · CNPJ 10.214.659/0001-02,
                            plataforma de agentes de IA para atendimento,
                            com agentes especializados.
                        </p>
                    </div>

                    <div className="conf-grid">
                        <div className="conf-item reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 6L9 17l-5-5" />
                                </svg>
                            </div>
                            <div>
                                <strong>7 dias grátis para testar</strong>
                                <span>Você experimenta o agente funcionando de verdade antes de decidir qualquer coisa.</span>
                            </div>
                        </div>

                        <div className="conf-item reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <rect x="5" y="11" width="14" height="10" rx="2"/>
                                    <path d="M8 11V7a4 4 0 018 0v4" />
                                </svg>
                            </div>
                            <div>
                                <strong>Segurança dos dados</strong>
                                <span>Informações de pacientes e profissionais tratadas com os devidos cuidados de privacidade.</span>
                            </div>
                        </div>

                        <div className="conf-item reveal">
                            <div className="ic">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M13 2L3 14h8l-1 8 10-12h-8z" />
                                </svg>
                            </div>
                            <div>
                                <strong>Plataforma amigável</strong>
                                <span>Não precisa instalar nada e não requer nenhum conhecimento técnico.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* FAQ */}
            <section className="faq" id="faq">
                <div className="wrap">
                    <div className="section-head reveal">
                        <span className="eyebrow">Dúvidas comuns</span>
                        <h2>Dúvidas que você possa ter antes de começar.</h2>
                    </div>

                    <div className="faq-list reveal">

                        <div className="faq-item">
                            <button type="button" className="faq-q">Posso testar gratuitamente mesmo?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>Sim, você cria seu agente, lhe concedemos uma linha e uma agenda exclusiva e você tem 7 dias para testar sem custo algum. Caso opte em não fazer a assinatura, basta apenas deixar expirar os 7 dias.</p>
                            </div>
                        </div>

                        <div className="faq-item">
                            <button type="button" className="faq-q">Posso realizar testes de agendamento?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>É muito importante, pois é nessa situação que você verá como o agente interaje com seus pacientes, como ele agenda horários e etc.</p>
                            </div>
                        </div>

                        <div className="faq-item">
                            <button type="button" className="faq-q">Como aciono meu agente?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>Depois que você criou o agente, basta dar um "oi" ou enviar qualquer mensagem para o número de telefone que fornecemos a você.</p>
                            </div>
                        </div>

                        <div className="faq-item">
                            <button type="button" className="faq-q">Qual é o canal de comunicação que o agente atua?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>O agente faz o atendimento através de uma linha de WhatsApp. Fique tranquilo, nós fornecemos a linha para você.</p>
                            </div>
                        </div>

                        <div className="faq-item">
                            <button type="button" className="faq-q">Se eu gostar, como faço a assinatura?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>Você pode fazer a assinatura a qualquer momento durante o período de teste (7 dias). No Painel do cliente, basta clicar em "Assinar".</p>
                            </div>
                        </div>

                        <div className="faq-item">
                            <button type="button" className="faq-q">Quais as vantegens em ser assinante?<span className="plus">+</span></button>
                            <div className="faq-a">
                                <p>Existem muitas, as principais são: número de linha reservado, acesso a todos os recursos da plataforma, personalização total da agenda, acompanhamento de performance do agente, entre outras.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            {/* CTA final */}
            <section className="cta-final" id="demonstracao">
                <div className="wrap">
                    <div className="cta-copy reveal">
                        <span className="eyebrow">Próximo passo</span>
                        <h2>Começe agora, é simples.</h2>
                        <p>Em poucos minutos você cria e configura seu agente.<br />Conheça todo o potencial de um atendimento baseado em inteligência artificial.</p>

                        <ul className="cta-final-list">
                            <li>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>7 dias grátis para testar
                            </li>

                            <li>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>Linha de WhatsApp excluisa</li>
                            <li>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6L9 17l-5-5" /></svg>Agenda exclusiva e personalizada</li>
                        </ul>

                    </div>

                    {/*<div className="form-card reveal">
                        
                        
                        <h3>
                            Passos:
                        </h3>

                        <p className="sub">Preencha os dados abaixo. Retornamos rapidinho.</p>


                        <form
                            id="leadForm"
                            method="POST"
                            action=""
                            noValidate
                        >

                            <div className="field-group">
                                <label htmlFor="clinica">Um breve cadastro</label>
                                <input type="text" id="clinica" name="clinica" placeholder="Nome da sua clínica ou consultório" required />
                            </div>


                            <div className="field-group">

                                <label htmlFor="nome">
                                    Nome do responsável
                                </label>

                                <input
                                    type="text"
                                    id="nome"
                                    name="nome"
                                    placeholder="Seu nome completo"
                                    required
                                />

                            </div>


                            <div className="field-row">

                                <div className="field-group">

                                    <label htmlFor="email">
                                        E-mail
                                    </label>

                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="seu@email.com"
                                        required
                                    />

                                </div>


                                <div className="field-group">

                                    <label htmlFor="whatsapp">
                                        Telefone
                                    </label>

                                    <input
                                        type="tel"
                                        id="whatsapp"
                                        name="whatsapp"
                                        placeholder="(00) 00000-0000"
                                        required
                                    />

                                </div>

                            </div>


                            <label className="consent">

                                <input
                                    type="checkbox"
                                    id="consent"
                                    name="consent"
                                    required
                                />

                                Autorizo o contato da Winners AI / Brev
                                Partner por telefone, WhatsApp e e-mail
                                para tratar da demonstração solicitada, e
                                concordo com o uso dos meus dados
                                exclusivamente para essa finalidade.

                            </label>
                        */}

                            <div className="cta-button-wrap">
                                <Link to="/register" className="btn btn-secondary" onClick={() => {logEvent(analytics, "lp_button_click", {button: "testar_form"});}}>QUERO TESTAR GRATUITAMENTE</Link>
                            </div>

                            {/*<p className="form-msg error" id="formError"> Por favor, preencha todos os campos corretamente.</p>

                        </form>

                    </div>*/}
                </div>

            </section>


            {/* Footer */}
            <footer>

                <div className="wrap">
                    <div className="footer-grid">
                        <div className="footer-brand">
                            <a href="#" className="logo"><img src={logo} alt="Winners AI" style={{height: "30px"}}/></a>
                            <p className="footer-tagline">Agentes especializados</p>
                        </div>
                        <nav className="footer-col footer-nav">
                            <span className="footer-col-title">Navegação</span>
                            <a href="#como-funciona">Como funciona</a>
                            <a href="#beneficios">Benefícios</a>
                            <a href="#especialidades">Para quem é</a>
                            <a href="#faq">Dúvidas</a>
                        </nav>

                        <div className="footer-col footer-contact-col">
                            <span className="footer-col-title">Contato</span>

                            {/*<a href="tel:+551153046350"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" /></svg>(11) 5304-6350</a>*/}

                            <a href="mailto:suporte@winners-ai.com"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16v16H4z" opacity="0"/><path d="M22 6l-10 7L2 6" /><rect x="2" y="4" width="20" height="16" rx="2"/></svg>suporte@winners-ai.com</a>

                            {/*<a href="https://wa.me/55SEUNUMEROAQUI?text=Oi!%20Vi%20a%20p%C3%A1gina%20da%20Winners%20AI%20e%20queria%20ver%20como%20funciona%20o%20agendamento%20autom%C3%A1tico." className="footer-wa" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.5 2 2 6.5 2 12c0 1.9.5 3.7 1.5 5.2L2 22l4.9-1.3c1.5.8 3.2 1.2 4.9 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.3.9.9-3.2-.2-.3C3.9 14.7 3.5 13.4 3.5 12 3.5 7.3 7.3 3.5 12 3.5s8.5 3.8 8.5 8.5-3.8 8.2-8.5 8.2z" /></svg>Ainda com dúvidas? Fale com o agente</a>*/}

                        </div>
                    </div>

                    <p className="footer-legal">Winners Ltda · CNPJ 10.214.659/0001-02</p>

                    <div className="footer-bottom" id="footerBottomRow">
                        <span>© 2026 Winners AI. Todos os direitos reservados.</span>
                        <span>Desenvolvido por{" "}<a href="https://brevpartner.com.br/" target="_blank" rel="noopener">Brev Partner</a></span>
                    </div>

                </div>

            </footer>


            {/* WhatsApp */}
            <div className="wa-float-wrap" id="waFloatWrap">
                <span className="wa-tooltip" id="waTooltip">fale com nosso agente{" "}<strong>→</strong> </span>
                <a href="#" className="wa-float" id="waFloat" aria-label="Falar com o agente da Winners-AI" onClick={(e) => {e.preventDefault(); setChatOpen(true);}}>
                    <span className="wa-pulse"></span>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.5 14.4c-.3-.1-1.7-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.3-.4.1-.2 0-.3 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.3-.3.3-1 1-1 2.4s1.1 2.8 1.2 3c.1.2 2.2 3.4 5.4 4.7.8.3 1.4.5 1.8.7.8.2 1.5.2 2 .1.6-.1 1.7-.7 2-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3z" />
                        <path d="M12 2C6.5 2 2 6.5 2 12c0 1.9.5 3.7 1.5 5.2L2 22l4.9-1.3c1.5.8 3.2 1.2 4.9 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.3.9.9-3.2-.2-.3C3.9 14.7 3.5 13.4 3.5 12 3.5 7.3 7.3 3.5 12 3.5s8.5 3.8 8.5 8.5-3.8 8.2-8.5 8.2z" />
                    </svg>
                </a>
            </div>
            {chatOpen && (
                <div className="footer_chat_overlay">
                    <div className="footer_chat_modal">
                        <div className="footer_chat_header">
                            <span>Suporte Winners AI</span>
                            <button onClick={() => setChatOpen(false)}>✕</button>
                        </div>
                        <SupportChat />
                    </div>
                </div>
            )}

            {/* CTA fixo mobile */}
            <a href="#demonstracao" className="btn btn-cta btn-block floating-cta" id="floatingCta">Solicitar Demonstração</a>
        </div>
    );
}

